
import { defineComponent, PropType, computed } from 'vue'

enum DesignSystemColor {
  default = 'default',
  primary = 'primary',
  error = 'error',
  contrast = 'primary-contrast',
  inverse = 'inverse-primary'
}
const buttonColorPropValues = Object.values(DesignSystemColor) as [string]

enum DesignSystemButtonStyle {
  filled = 'filled',
  outline = 'outline',
  text = 'text'
}
const buttonStylePropValues = Object.values(DesignSystemButtonStyle) as [string]

export default defineComponent({
  name: 'BBButton',
  emits: ['button-clicked'],
  props: {
    label: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    icon: {
      type: Boolean,
      default: false
    },
    buttonColor: {
      type: String as PropType<DesignSystemColor>,
      validator: (val: string) => buttonColorPropValues.includes(val),
      default: 'default'
    },
    buttonStyle: {
      type: String as PropType<DesignSystemButtonStyle>,
      validator: (val: string) => buttonStylePropValues.includes(val),
      default: 'filled'
    }
  },
  setup(props) {
    const classObject = computed(() => ({
      'bb-button': true,
      'bb-icon-button': props.icon
    }))

    return {
      classObject
    }
  }
})
